// extracted by mini-css-extract-plugin
export default {"container":"Address_container__sh1np","title":"Address_title__e8vqG","modal":"Address_modal__QH7FM","header":"Address_header__HlKWN"};